export const eulerSwapAddresses = {
  eulerSwapV1Factory: "0xE25B3cdA6fccAcbD794aEA64eE1B496d7b441644",
  eulerSwapV1Implementation: "0x334eac29ffAc27E6BC3484A738DAf520359698F0",
  eulerSwapV1Periphery: "0x199cC7C8606088bc22D82CDae2D7EE7F5F99ec9F",
} as const
